// =============================
// src/components/Header.tsx
// =============================
import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  // Close menu on route change
  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  return (
    <header className="fixed top-0 left-0 w-full z-50 border-b border-gray-800/70 bg-black/60 backdrop-blur supports-[backdrop-filter]:bg-black/40">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="text-purple-300 font-bold text-xl tracking-wider hover:text-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-500 rounded"
        >
          X’d Out RP
        </Link>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-xl border border-white/10 text-white focus:outline-none focus:ring-2 focus:ring-purple-500"
          aria-label="Toggle navigation menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((v) => !v)}
        >
          <span className="text-2xl leading-none">☰</span>
        </button>

        {/* Nav Links */}
        <nav
          className={`${
            isOpen ? "flex" : "hidden"
          } absolute top-full left-0 w-full bg-black/95 md:bg-transparent md:static md:flex md:w-auto flex-col md:flex-row gap-4 md:gap-6 px-6 py-4 md:p-0`}
          aria-label="Primary"
        >
          <NavLink
            to="/"
            className={({ isActive }) =>
              `block transition hover:text-white ${
                isActive ? "text-white" : "text-gray-300"
              }`
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/rules"
            className={({ isActive }) =>
              `block transition hover:text-white ${
                isActive ? "text-white" : "text-gray-300"
              }`
            }
          >
            Rules
          </NavLink>
          <a
            href="https://store.xout.gg"
            target="_blank"
            rel="noopener noreferrer"
            className="block transition text-yellow-400 hover:text-yellow-300"
          >
            Store
          </a>
          <a
            href="https://discord.gg/taZ6BJPYEv"
            target="_blank"
            rel="noopener noreferrer"
            className="block text-purple-400 hover:text-purple-300 transition"
          >
            Join Discord
          </a>
        </nav>
      </div>
    </header>
  );
}